import { call, put } from 'redux-saga/effects';

import { apiGeneral, notify } from 'services';
import { IFechRequest } from 'interfaces/fetch-duck';
import { requestErrorHandler } from 'utils';
import { FetchCompanyActions } from 'store/ducks/settings/companies';

export function* fetchCompanyRequest(action: any) {
  try {
    const { id, onSuccess } = action as IFechRequest;
    const { data } = yield call(apiGeneral.get, `/companies/${id}`);

    yield put(FetchCompanyActions.success(data));
    if (onSuccess) onSuccess(data);
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify('error', errorMessage);
    yield put(FetchCompanyActions.failure(errorMessage));
  }
}
